import React from 'react';
import { node, bool } from 'prop-types';
import { Heading } from 'components/common';

import './FunnelTip.scss';

const FunnelTip = ({ center, children }) => (
  <div className="funnel-tip">
    <Heading
      as="h4"
      style={{
        ...center && { margin: '0 auto' },
      }}
    >
      <span className="highlight">
        {children}
      </span>
    </Heading>
  </div>
);

FunnelTip.propTypes = {
  center: bool,
  children: node,
};

FunnelTip.defaultProps = {
  center: false,
  children: null,
};

export default FunnelTip;
